import numeral from "numeral";
import { useMemo } from "react";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { ImageMain } from "../../../components/img/Img.Main";
import { cn } from "../../../utils/useFunctions";
import { ChartCashFlow } from "../../future_plan/components/VIChartCashFlow.Main";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE, STYLE_PDF_TEXT_MEDIUM_BLUE_12 } from "../styles/pdf.style";

function PdfPageFutureFour({
  page,
  userData,
  moneyNeedLists,
  is_Last = false,
}) {
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);

  const merge_keys = useMemo(() => {
    let income_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("income");
      }
    );
    let expenese_keys = futurePlanData?.cash_flow_keys?.filter(
      (cash_flow_key) => {
        return cash_flow_key.includes("expenese");
      }
    );
    let merge_income_keys = [
      ...income_keys,
      "income_peryear",
      "remain_accumulate",
    ];
    let merge_expenese_keys = [...expenese_keys, "outcome_peryear"];
    let merge_keys = [...merge_expenese_keys, ...merge_income_keys];
    return merge_keys;
  }, [futurePlanData]);

  const dataDebt = useMemo(() => {
    let dataDebt = [];

    for (const merge_key of merge_keys) {
      let dataDebtItems = [];
      for (const cash_flow_item of futurePlanData.cash_flow_items) {
        if (cash_flow_item[merge_key] !== undefined) {
          let amount = String(merge_key).startsWith("expenese")
            ? -cash_flow_item[merge_key]
            : cash_flow_item[merge_key];

          amount = Math.round(amount);
          if ([0, -0].includes(amount)) {
            amount = "";
          }

          dataDebtItems.push(amount);
        }
      }
      dataDebt.push(dataDebtItems);
    }

    return dataDebt;
  }, [futurePlanData]);

  const labels = useMemo(() => {
    let labels = [];
    for (const cash_flow_item of futurePlanData.cash_flow_items) {
      labels.push(cash_flow_item.age);
    }
    return labels;
  }, [futurePlanData]);

  //   expenese_home_items: "บ้าน",
  //   expenese_car_items: "รถ",
  //   expenese_children_items: "ลูก",
  //   expenese_travel_items: "ท่องเที่ยว",
  //   expenese_collection_items: "ของสะสม",
  //   expenese_other_items: "รายจ่ายอื่นๆ",
  //   income_legacy_items: "รายรับจากมรดก",
  //   income_business_items: "รายรับจากธุรกิจ",
  //   income_property_items: "รายรับจากอสังหาริม",
  //   income_other_items: "รายรับอื่นๆ",
  //   income_peryear: "รายรับต่อปี",
  //   remain_accumulate: "ยอดเงินสะสม",
  //   outcome_peryear: "รายจ่ายต่อปี",

  const colors = useMemo(() => {
    return merge_keys?.map((key) => {
      if (key === "income_peryear") {
        return { label: "รายรับต่อปี", color: "#47A3F7" };
      } else if (key === "remain_accumulate") {
        return { label: "ยอดเงินสะสม", color: "#00B61D" };
      } else if (key === "outcome_peryear") {
        return { label: "รายจ่ายต่อปี", color: "#F7A647" };
      } else if (key === "expenese_home_items") {
        return { label: "บ้าน", color: "#FFD12C" };
      } else if (key === "expenese_car_items") {
        return { label: "รถ", color: "#AF2CFF" };
      } else if (key === "expenese_children_items") {
        return { label: "ลูก", color: "#FF00FF" };
      } else if (key === "expenese_travel_items") {
        return { label: "ท่องเที่ยว", color: "#00FF00" };
      } else if (key === "expenese_collection_items") {
        return { label: "ของสะสม", color: "#FB3CBD" };
      } else if (key === "expenese_other_items") {
        return { label: "รายจ่ายอื่นๆ", color: "#BDC333" };
      } else if (key === "income_legacy_items") {
        return { label: "รายรับจากมรดก", color: "#FF0000" };
      } else if (key === "income_business_items") {
        return { label: "รายรับจากธุรกิจ", color: "#00FFFF" };
      } else if (key === "income_property_items") {
        return { label: "รายรับจากอสังหาริม", color: "#FFA500" };
      } else if (key === "income_other_items") {
        return { label: "รายรับอื่นๆ", color: "#0000FF" };
      }
    });
  }, [dataDebt]);

  const moneyNeed = useMemo(() => {
    const findData = futurePlanData?.cash_flow_items?.filter((item) => {
      return item?.remain_accumulate < 0 && item?.remain < 0;
    });
    return findData;
  }, []);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="แผนอนาคต"
        icon="/images/personal.svg"
        classNameIcon="w-[24px] h-[27px]"
      />
      {/* Cash Flow */}
      <PdfCard
        className={""}
        title={"กระแสเงินสดรายรับรายจ่ายของแผนอนาคต"}
        classNameTitle={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_12)}
      >
        {!userData?.is_premium && (
          <PdfCardWhite>
            <div className="w-full h-full">
              <ChartCashFlow
                labels={labels}
                dataDebt={dataDebt}
                merge_keys={merge_keys}
              />
            </div>
          </PdfCardWhite>
        )}

        <PdfCardWhite className={"mt-3"}>
          {moneyNeedLists?.length > 0 &&
            moneyNeedLists?.map((item, index) => {
              return (
                <div key={index} className="flex justify-between w-full">
                  <div>{`อายุ ${item?.age} คุณต้องหารายรับเพิ่มอีก `}</div>
                  <div className="">
                    {`${numeral(Math.abs(item?.remain))?.format("0,0")} บาท`}
                  </div>
                </div>
              );
            })}
          {is_Last && (
            <div className="  w-full rounded-lg h-full p-3 space-y-[6px]">
              <ImageMain
                src="../images/cashflow.png"
                className=" w-12 h-12 mx-auto"
              />

              <div className=" text-center text-mainblue text-sm ">
                เพื่อทำให้แผนอนาคตของคุณเป็นไปตามเป้าหมาย
                <div>
                  คุณต้องหารายรับเพิ่มอีก
                  <span className=" font-semibold">
                    {" "}
                    {numeral(
                      Math.abs(
                        moneyNeed?.reduce((acc, cur) => {
                          return acc + cur?.remain;
                        }, 0)
                      )
                    )?.format("0,0")}{" "}
                    บาท
                  </span>{" "}
                </div>
              </div>
            </div>
          )}
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageFutureFour;
